import React from 'react';
import useSWR from "swr";
import axios from "axios";
import {convertImagePath} from "../../../../stores/tools/commons";
import Image from "next/image";
import Link from 'next/link'
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

// import Swiper core and required modules
import SwiperCore, {
  Autoplay,Pagination,Navigation
} from 'swiper';
import colorPalette from "../../../../styles/theme/colorPalette";
import {css} from "@emotion/react";

// install Swiper modules
SwiperCore.use([Autoplay,Pagination,Navigation]);

const fetcher = url => axios.get(url).then(res => res.data);

const DietitiansCarousel = () => {
  const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/staffs/dietitians`
  const { data: data } = useSWR(url, fetcher);
  
  return (
      <div css={slideWrapper}>
        <Swiper
            spaceBetween={0}
            loop={true}
            pagination={{
              "clickable": true
            }}
            initialSlide={1}
            navigation={true}
            slidesPerView={3}
            breakpoints={{
              320: {
                slidesPerView: 3,
              },
              "640": {
                "slidesPerView": 3,
              },
              "768": {
                "slidesPerView": 3,
              },
              "1024": {
                "slidesPerView": 4,
              }
            }}
            centeredSlides={true}
            // autoplay={{
            //   "delay": 3000,
            //   "disableOnInteraction": false
            // }}
            className="mySwiper"
        >
          {
            data?.map((staff,i) => (
                <SwiperSlide
                    key={`${staff.id}_${i}`}
                >
                  <Link
                      href={`/staff/${staff.id}`}
                      as={`/dietitians/${staff.id}`}
                  >
                    <a>
                      <div css={imageWrapper}>
                        <Image
                            src={convertImagePath(
                                `staff/${staff.contact.user_name}.png`
                            )}
                            width={120}
                            height={125}
                            alt={staff.contact.user_name}
                        />
                      </div>
                    </a>
                  </Link>
                </SwiperSlide>
            ))
          }
        </Swiper>
      </div>
  );
};

export default DietitiansCarousel;

const slideWrapper = css`
  padding: 20px 0;
  .swiper-button-prev {
    border-radius: 100px 24px 24px 100px;
  }
  .swiper-button-next {
    border-radius: 24px 100px 100px 24px;
  }
  .swiper-button-prev, .swiper-button-next {
    background-color: rgba(255,255,255,0.9);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    &::after {
      font-size: 25px;
      font-weight: bold;
      color: ${colorPalette.primary};
    }
  }
`

const imageWrapper = css`
  margin: 8px;
  background-color: #efefef;
  overflow: hidden;
  border-radius: 100px 100px 8px 8px;
  text-align: center;
  > div {
    bottom: -10px;
  }
`